<template>
  <div class="edit-page-container">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <!-- ══ BACK ACTION BANNER ══ -->
    <div class="rm-detail-header">
      <v-btn text class="back-btn" @click="$router.push('/rescuers')">
        <v-icon left>mdi-arrow-left</v-icon>
        Back to Directory
      </v-btn>
      <div class="rm-detail-header__title">
        <v-icon color="#4ADE80" class="mr-2" size="22">mdi-account-edit-outline</v-icon>
        Edit Rescuer Profile
      </div>
    </div>

    <!-- ══ MAIN CONTENT GRID ══ -->
    <div class="edit-page-content pa-6">
      <v-row class="ma-0">
        <!-- Left Column: Details Section Cards -->
        <v-col cols="12" md="8" lg="9" class="pa-2">
          <!-- Card 1: Personal Details -->
          <v-card class="detail-section-card pa-6 mb-6 elevation-0">
            <h3 class="section-title mb-5">
              <v-icon color="#14532D" class="mr-2" size="20">mdi-account-outline</v-icon>
              Personal Details
            </h3>
            <v-row>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Full Name</span>
                  <v-text-field
                    v-model="name"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Enter name"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Education</span>
                  <v-text-field
                    v-model="education"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Education qualifications"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Employment</span>
                  <v-text-field
                    v-model="employment"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Employment status / Occupation"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Blood Group</span>
                  <v-text-field
                    v-model="bloodGroup"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="e.g. O+ve"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Aadhar Number</span>
                  <v-text-field
                    v-model="adharnumber"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="12 digit Aadhar Number"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">District</span>
                  <v-text-field
                    v-model="district"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="District name"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>

          <!-- Card 2: Contact & Credentials -->
          <v-card class="detail-section-card pa-6 mb-6 elevation-0">
            <h3 class="section-title mb-5">
              <v-icon color="#14532D" class="mr-2" size="20">mdi-card-account-phone-outline</v-icon>
              Contact & Credentials
            </h3>
            <v-row>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Username</span>
                  <v-text-field
                    v-model="username"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Username"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Email Address</span>
                  <v-text-field
                    v-model="email"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Email address"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Phone Number</span>
                  <v-text-field
                    v-model="phone"
                    type="number"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="10 digit phone number"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Organization</span>
                  <v-text-field
                    v-model="organization"
                    outlined
                    dense
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Organization name"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>

          <!-- Card 3: Addresses -->
          <v-card class="detail-section-card pa-6 mb-6 elevation-0">
            <h3 class="section-title mb-5">
              <v-icon color="#14532D" class="mr-2" size="20">mdi-map-marker-outline</v-icon>
              Addresses
            </h3>
            <v-row>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Present Address</span>
                  <v-textarea
                    v-model="presentAddress"
                    outlined
                    rows="3"
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Present address details"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="py-2">
                <div class="input-field-wrapper">
                  <span class="input-field-label">Permanent Address</span>
                  <v-textarea
                    v-model="permanentAddress"
                    outlined
                    rows="3"
                    color="#14532D"
                    hide-details="auto"
                    placeholder="Permanent address details"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Right Column: Status Configuration & Security -->
        <v-col cols="12" md="4" lg="3" class="pa-2">
          <!-- Card 4: Rescuer Configuration -->
          <v-card class="detail-section-card pa-6 mb-6 elevation-0">
            <h3 class="section-title mb-5">
              <v-icon color="#14532D" class="mr-2" size="20">mdi-cog-outline</v-icon>
              Status & Config
            </h3>
            
            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Rescuer Code</span>
              <v-text-field
                v-model="rescuerCode"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
                placeholder="Rescuer code"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">ID Type</span>
              <v-text-field
                v-model="idType"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
                placeholder="ID Type"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Rescuer ID</span>
              <v-text-field
                v-model="idNumber"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
                placeholder="Rescuer ID Number"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Rescue Started At (in years)</span>
              <v-text-field
                v-model="rescueStartedAt"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
                placeholder="Years active"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Disease Status</span>
              <v-select
                v-model="diseaseStatus"
                :items="diseaseStatusitems"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Is Rescuer</span>
              <v-select
                v-model="is_rescuer"
                :items="isrescueravailableitems"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Is Snake Expert?</span>
              <v-select
                v-model="issnakeexpert"
                :items="issnakeexpertitems"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
              />
            </div>

            <div class="input-field-wrapper mb-4">
              <span class="input-field-label">Is Rescuer Available?</span>
              <v-select
                v-model="is_rescuer_Available"
                :items="isrescueravailableitems"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
              />
            </div>

            <div class="input-field-wrapper mb-6">
              <span class="input-field-label">Is District Coordinator</span>
              <v-select
                v-model="districtCoordinator"
                :items="districtCoordinatoritems"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
              />
            </div>

            <v-btn
              block
              depressed
              large
              color="#14532D"
              class="white--text update-btn"
              @click="handlesubmit()"
            >
              <v-icon left>mdi-content-save-outline</v-icon>
              Update Details
            </v-btn>
          </v-card>

          <!-- Card 5: Security & Password -->
          <v-card class="detail-section-card pa-6 elevation-0">
            <h3 class="section-title mb-5">
              <v-icon color="#14532D" class="mr-2" size="20">mdi-shield-lock-outline</v-icon>
              Security Settings
            </h3>
            
            <div class="input-field-wrapper mb-6">
              <span class="input-field-label">New Password</span>
              <v-text-field
                v-model="password"
                type="password"
                outlined
                dense
                color="#14532D"
                hide-details="auto"
                placeholder="Enter new password"
              />
            </div>

            <v-btn
              block
              depressed
              large
              outlined
              color="#14532D"
              class="update-password-btn"
              @click="updatepassword()"
            >
              <v-icon left>mdi-key-variant</v-icon>
              Update Password
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  <script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      issnakeexpertitems: ["Yes", "No"],
      isrescueravailableitems: ["Yes", "No"],
      isrescueritems: ["Yes", "No"],
      diseaseStatusitems: ["Yes", "No"],
      diseaseStatus: "",
      districtCoordinator: "",
      districtCoordinatoritems: ["Yes", "No"],
      username: "",
      name: "",
      phone: "",
      idType: "",
      idNumber: "",
      email: "",
      error: "",
      organization: "",
      is_rescuer: "",
      issnakeexpert: "",
      is_rescuer_Available: "",
      password: "",
      rescuerCode: "",
      adharnumber: "",
      bloodGroup: "",
      district: "",
      education: "",
      rescueStartedAt: "",
      permanentAddress: "",
      presentAddress: "",
      employment: "",
      resid: "",
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    openEditDialog(item) {
      this.$router.push({
        path: "/edituser",
        query: {
          id: item._id,
        },
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.username = response.data.data.username;
              this.name = response.data.data.name;
              this.email = response.data.data.email;
              this.phone = response.data.data.phone;
              if (response.data.rescuer) {
                this.idType = response.data.rescuer.idType;
                this.rescuerCode = response.data.rescuer.rescuerCode;
                this.rescuerCode = response.data.rescuer.rescuerCode;
                this.idNumber = response.data.rescuer.idNumber;
                this.district = response.data.rescuer.district;
                this.presentAddress = response.data.rescuer.presentAddress;
                this.rescueStartedAt = response.data.rescuer.rescueStartedAt;
                this.adharnumber = response.data.rescuer.adharnumber;
                this.bloodGroup = response.data.rescuer.bloodGroup;
                this.diseaseStatus = response.data.rescuer.diseaseStatus;
                this.employment = response.data.rescuer.employment;
                this.resid = response.data.rescuer._id;
                this.education = response.data.rescuer.education;
                this.permanentAddress = response.data.rescuer.permanentAddress;
                this.districtCoordinator = response.data.rescuer.districtCoordinator;
              }
              this.organization = response.data.data.organization;
              this.is_rescuer = response.data.data.is_rescuer;
              this.issnakeexpert = response.data.data.issnakeexpert;
              

              this.is_rescuer_Available =
                response.data.data.is_rescuer_Available;
              if (this.is_rescuer === true) {
                this.is_rescuer = "Yes";
              }
              if (this.is_rescuer === false) {
                this.is_rescuer = "No";
              }
              if (this.is_rescuer_Available === true) {
                this.is_rescuer_Available = "Yes";
              }
              if (this.is_rescuer_Available === false) {
                this.is_rescuer_Available = "No";
              }
              if (this.issnakeexpert === true) {
                this.issnakeexpert = "Yes";
              }
              if (this.issnakeexpert === false) {
                this.issnakeexpert = "No";
              }
              if (this.districtCoordinator === true) {
                this.districtCoordinator = "Yes";
              }
              if (this.districtCoordinator === false) {
                this.districtCoordinator = "No";
              }
              if (this.diseaseStatus === true) {
                this.diseaseStatus = "Yes";
              }
              if (this.diseaseStatus === false) {
                this.diseaseStatus = "No";
              }
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    handlesubmit() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.email)) {
        this.msg = "Please enter a valid email address.";
        this.showSnackBar = true;
        return;
      }
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(this.phone)) {
        this.msg = "Please enter a valid 10-digit phone number.";
        this.showSnackBar = true;
        return;
      }

      if (this.is_rescuer === "Yes") {
        this.isrescueredit = true;
      }
      if (this.is_rescuer === "No") {
        this.isrescueredit = false;
      }
      if (this.is_rescuer_Available === "Yes") {
        this.isrescuerAvailableedit = true;
      }
      if (this.is_rescuer_Available === "No") {
        this.isrescuerAvailableedit = false;
      }
      if (this.issnakeexpert === "Yes") {
        this.issnakeexpertedit = true;
      }
      if (this.issnakeexpert === "No") {
        this.issnakeexpertedit = false;
      }
      if (this.diseaseStatus === "Yes") {
        this.diseaseStatusedit = true;
      }
      if (this.diseaseStatus === "No") {
        this.diseaseStatusedit = false;
      }
      if (this.districtCoordinator === "Yes") {
        this.districtCoordinatoredit = true;
      }
      if (this.districtCoordinator === "No") {
        this.districtCoordinatoredit = false;
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/adminrescueredit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.resid,
          name: this.name,
          username: this.username,
          email: this.email,
          phone: this.phone,
          bloodGroup: this.bloodGroup,
          adharnumber: this.adharnumber,
          district: this.district,
          education: this.education,
          employment: this.employment,
          idNumber: this.idNumber,
          idType: this.idType,
          permanentAddress: this.permanentAddress,
          presentAddress: this.presentAddress,
          rescueStartedAt: this.rescueStartedAt,
          rescuerCode: this.rescuerCode,
          organization: this.organization,

          districtCoordinator: this.districtCoordinatoredit,
          diseaseStatus: this.diseaseStatusedit,
          is_rescuer: this.isrescueredit,
          is_rescuer_Available: this.isrescuerAvailableedit,
          issnakeexpert: this.issnakeexpertedit,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    updatepassword() {
      if (!this.password) {
        this.msg = "Please enter password to update.";
        this.showSnackBar = true;
        return;
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/editpassword",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.id,
          password: this.password,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Password Updated Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
/* ── Container Background ── */
.edit-page-container {
  background-color: #F8FAFC;
  min-height: 100vh;
}

/* ── Header Banner ── */
.rm-detail-header {
  background: linear-gradient(135deg, #0A2318 0%, #14532D 55%, #166534 100%);
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}
.back-btn {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.01em !important;
  background: rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  padding: 0 12px !important;
  height: 36px !important;
}
.back-btn:hover {
  background: rgba(255, 255, 255, 0.16) !important;
}
.rm-detail-header__title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
}

/* ── Info & Form Cards ── */
.detail-section-card {
  background: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.02) !important;
}
.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1E293B;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F1F5F9;
  padding-bottom: 10px;
}

/* ── Input Wrapper & Style ── */
.input-field-wrapper {
  display: flex;
  flex-direction: column;
}
.input-field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748B;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}

/* ── Buttons ── */
.update-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  letter-spacing: 0.02em !important;
  box-shadow: 0 4px 12px rgba(20, 83, 45, 0.15) !important;
  transition: all 0.2s ease !important;
}
.update-btn:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}
.update-password-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  letter-spacing: 0.02em !important;
  transition: all 0.2s ease !important;
}
.update-password-btn:hover {
  background-color: rgba(20, 83, 45, 0.04) !important;
  transform: translateY(-1px);
}
</style>